import { render, staticRenderFns } from "./Chi_wineListItem.vue?vue&type=template&id=4daa0f12&scoped=true"
import script from "./Chi_wineListItem.vue?vue&type=script&lang=ts"
export * from "./Chi_wineListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa0f12",
  null
  
)

export default component.exports